import {
  FormMultiSelectChip as ExprWorksFormMultiSelectChip,
  MultiSelectChipProps,
} from '@diagentech/exprworks-ui-components';
import React from 'react';

import { useAppSelector } from '@/App/hooks';
import { withDisplayRule } from '@/features/displayRules/withDisplayRule';
import { selectRefDataValues } from '@/features/refdata/selectRefDataValues';
import { PageFragmentProps } from '@/features/withPageFragmentInit';

export type FormMultiSelectChipProps = Omit<MultiSelectChipProps, 'options'> & PageFragmentProps;

const FormMultiSelectChip: React.FC<FormMultiSelectChipProps> = (props) => {
  const { screenRef, actionRef, id, ...rest } = props;
  const options = useAppSelector(selectRefDataValues(screenRef, actionRef, id));

  return <ExprWorksFormMultiSelectChip {...rest} id={id} options={options} />;
};

export const FormRdrMultiSelectChip = withDisplayRule(FormMultiSelectChip);
